import { NavLink as Link } from 'react-router-dom';
import Icon from '../icons/icon';
import Text from '../typography/v2/text';

import { IconType } from '../../types/icon.type';
import Container from '../containers/container';
import { HStack } from '../layouts/stack.layout';

type NavigationLinkProps = {
  active: boolean;
  href: string;
  text: string;
  icon: IconType;
};

export const ALTERNATIVE_ICON: { [key: string]: IconType } = {
  home: 'alt-home',
  discover: 'alt-discover',
  saved: 'alt-saved',
  spaces: 'alt-spaces',
  events: 'alt-events',
  releases: 'alt-releases',
  subscriptions: 'alt-subscriptions',
  notifications: 'alt-notifications',
};

export function NavigationLink(props: NavigationLinkProps) {
  const { active, href, text, icon } = props;

  return (
    <Link to={href}>
      <HStack extensions="items-center w-fit p-3">
        <Icon
          icon={active ? ALTERNATIVE_ICON[icon] : icon}
          size="md"
          color={active ? 'primary' : 'gray'}
        />
        <Container extensions="mobile:hidden desktop:block mx-3">
          <Text variant={active ? 'active-navigation' : 'navigation'}>
            {text}
          </Text>
        </Container>
      </HStack>
    </Link>
  );
}
